var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.pageTitle } },
    [
      _c("template", { slot: "pageContent" }, [
        _vm.isSmartphoneOS
          ? _c(
              "div",
              { staticClass: "mb-3", attrs: { slot: "fixed" }, slot: "fixed" },
              [
                _c(
                  "div",
                  { staticClass: "top-44px w-100" },
                  [
                    _vm.serviceId === _vm.services.PAYMENTS && _vm.mode === 2
                      ? _c("cm-messages-filter", {
                          ref: "filter",
                          staticClass: "researchfilter position-relative z-10",
                          attrs: {
                            isPayments: "",
                            received: "",
                            filterType: "group",
                            mode: _vm.mode,
                          },
                          on: {
                            extractCSV: function ($event) {
                              return _vm.extractCSV(_vm.inboxMessages)
                            },
                            applyFilter: function ($event) {
                              return _vm.applyFilter($event)
                            },
                            refreshInbox: function ($event) {
                              return _vm.refreshInbox()
                            },
                          },
                        })
                      : _c("cm-messages-filter", {
                          ref: "filter",
                          staticClass: "researchfilter position-relative z-10",
                          attrs: {
                            isPayments: "",
                            received: "",
                            filterType: "list",
                            mode: _vm.mode,
                          },
                          on: {
                            extractCSV: function ($event) {
                              return _vm.extractCSV(_vm.inboxMessages)
                            },
                            applyFilter: function ($event) {
                              return _vm.applyFilter($event)
                            },
                            refreshInbox: function ($event) {
                              return _vm.refreshInbox()
                            },
                          },
                        }),
                  ],
                  1
                ),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "listPage" },
          [
            _c(
              "b-row",
              [
                _c(
                  "b-col",
                  { attrs: { md: "12" } },
                  [
                    _c("div", { staticClass: "requestsList" }, [
                      !_vm.isSmartphoneOS
                        ? _c(
                            "div",
                            [
                              _vm.serviceId === _vm.services.PAYMENTS &&
                              _vm.mode === 2
                                ? _c("cm-messages-filter", {
                                    ref: "filter",
                                    staticClass:
                                      "researchfilter position-relative z-10",
                                    attrs: {
                                      isPayments: "",
                                      received: "",
                                      filterType: "group",
                                      mode: this.mode,
                                      randomId: _vm.randomId,
                                      propedServiceId: "1",
                                    },
                                    on: {
                                      extractCSV: function ($event) {
                                        return _vm.extractCSV(_vm.inboxMessages)
                                      },
                                      applyFilter: function ($event) {
                                        return _vm.applyFilter($event)
                                      },
                                      refreshInbox: function ($event) {
                                        return _vm.refreshInbox()
                                      },
                                    },
                                  })
                                : _c("cm-messages-filter", {
                                    ref: "filter",
                                    staticClass:
                                      "researchfilter position-relative z-10",
                                    attrs: {
                                      isPayments: "",
                                      received: "",
                                      filterType: "list",
                                      mode: this.mode,
                                      randomId: _vm.randomId,
                                      propedServiceId: "1",
                                    },
                                    on: {
                                      extractCSV: function ($event) {
                                        return _vm.extractCSV(_vm.inboxMessages)
                                      },
                                      applyFilter: function ($event) {
                                        return _vm.applyFilter($event)
                                      },
                                      refreshInbox: function ($event) {
                                        return _vm.refreshInbox()
                                      },
                                    },
                                  }),
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.isSmartphoneOS
                        ? _c("div", { class: _vm.customMobileLayoutStyle })
                        : _vm._e(),
                    ]),
                    _vm._v(" "),
                    _vm.activateSpinner
                      ? _c("spinner")
                      : _c(
                          "div",
                          [
                            _vm.hasResult
                              ? _c("b", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.$t(
                                        "common.monitoring.following_statistics_from_perimeter"
                                      )
                                    ) + " :"
                                  ),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.nbRTP
                              ? _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.nbRTP) +
                                        " " +
                                        _vm._s(
                                          _vm.$t("common.monitoring.RTP-001")
                                        )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.nbCreditNotes
                              ? _c("div", [
                                  _c("span", [
                                    _vm._v(
                                      _vm._s(_vm.nbCreditNotes) +
                                        " " +
                                        _vm._s(
                                          _vm.$t("common.monitoring.RTP-007")
                                        )
                                    ),
                                  ]),
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasResult
                              ? _c("graph-by-status", {
                                  attrs: {
                                    showAmountNotNumber: _vm.showingStatus,
                                    datasetData: _vm.statusGraph,
                                  },
                                })
                              : _vm._e(),
                            _vm._v(" "),
                            _vm.hasResult
                              ? _c("b-table", {
                                  key: _vm.resetFields,
                                  ref: "tableSuppliersList",
                                  staticClass: "mt-3",
                                  attrs: {
                                    striped: "",
                                    hover: "",
                                    fixed: "",
                                    selectable: "",
                                    items: _vm.items,
                                    fields: _vm.fields,
                                    "sort-by": _vm.sortField,
                                  },
                                  on: { "row-selected": _vm.checkList },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "cell(rtpi)",
                                        fn: function (data) {
                                          return [
                                            _c("span", {
                                              staticClass: "dot m-1",
                                              class: "dot" + data.value,
                                            }),
                                            _vm._v(
                                              _vm._s(
                                                _vm.$t(
                                                  "filter.feature." + data.value
                                                )
                                              )
                                            ),
                                          ]
                                        },
                                      },
                                      {
                                        key: "cell(count)",
                                        fn: function (data) {
                                          return [_vm._v(_vm._s(data.value))]
                                        },
                                      },
                                      {
                                        key: "cell(percent)",
                                        fn: function (data) {
                                          return [_vm._v(_vm._s(data.value))]
                                        },
                                      },
                                    ],
                                    null,
                                    false,
                                    1138916283
                                  ),
                                })
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "d-flex justify-content-center mt-5",
                                  },
                                  [
                                    _c("b", [
                                      _vm._v(
                                        _vm._s(_vm.$t("common.no_result"))
                                      ),
                                    ]),
                                  ]
                                ),
                          ],
                          1
                        ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }